import {
  Component,
  NgModule,
  OnDestroy,
  OnInit,
  EventEmitter,
  Input,
  Output,
  ViewContainerRef,
  OnChanges,
  TemplateRef,
  ViewEncapsulation,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { DemoService } from '../../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import { Routes, RouterModule, Router } from '@angular/router';
import { MysqlService } from './../../../../services/mysql.service';

// view iframes
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { Job } from '../../../../shared/models/job.model';
import { SystemFile } from '../../../../shared/models/file.model';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import {
  HttpClientModule,
  HttpRequest,
  HttpResponse,
  HttpEvent,
} from '@angular/common/http';
import { Location } from '@angular/common';

// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import { Observable, Subject, Subscription, map } from 'rxjs';
;
import { FileUploaderService } from './../../../../services/file-uploader-service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

import { SubjectCommunication } from '../../../../shared/models/subjectCommunication.model';
import { SubjectCommunicationAttatchments } from '../../../../shared/models/subjectCommunicationAttachments.model';
// import { ToolbarService, DocumentEditorContainerComponent } from '@syncfusion/ej2-angular-documenteditor';
// import { isNullOrUndefined } from '@syncfusion/ej2-base';
import {
  MultiSelectComponent,
  DropDownListComponent,
} from '@syncfusion/ej2-angular-dropdowns';

// DocX - https://docx.js.org/#/?id=welcome
// import { Document, Packer, Paragraph, TextRun } from 'docx';

import * as $ from 'jquery';
// see: https://www.youtube.com/watch?v=YPBcy6LSxsg

import {
  ToolbarService,
  LinkService,
  ImageService,
  HtmlEditorService,
} from '@syncfusion/ej2-angular-richtexteditor';
import {
  RichTextEditorComponent,
  NodeSelection,
} from '@syncfusion/ej2-angular-richtexteditor';
import { DialogUtility } from '@syncfusion/ej2-angular-popups';
import { GlobalFunctionsService } from './../../../../services/global-functions.service';
import { JobSubject } from './../../../../shared/models/jobSubject.model';
import { LegalDateTimeService } from './../../../../services/legal-datetime.service';

@Component({
  selector: 'app-subject-communication',
  templateUrl: './subject-communication.component.html',
  styleUrls: ['./subject-communication.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    ToolbarService,
    LinkService,
    ImageService,
    HtmlEditorService,
    MultiSelectComponent,
    DropDownListComponent,
  ],
})
export class SubjectCommunicationComponent implements OnInit {



// setup as observable?
@Input() item_id?: Observable<any[]>; // impliments on changes.
@Input() item_data?: Observable<any[]>; // if data.model is sent : Observable<any[]>;
@Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
@Input() item_user_level_id? = '5'; // default to agent just in case
@Input() item_brand_type_id? = '';
@Input() show_buttons? = 'no'; // yes | no
@Input() widget_title? = '';
@Input() widget_size? = 'side'; // side | abstract | full

// @Input() job_id?: Observable<any[]>; // impliments on changes.
@Output('closeParentModel') closeParentModel: EventEmitter<any> = new EventEmitter();
@Output('closeParentModel3') closeParentModel3: EventEmitter<any> = new EventEmitter();
@Output('refreshParentGrid') refreshParentGrid: EventEmitter<any> = new EventEmitter();
@Output('refreshInvoiceItemsBelow') refreshInvoiceItemsBelow: EventEmitter<any> = new EventEmitter();
@Output('refreshSujectInvoicePage') refreshSujectInvoicePage: EventEmitter<any> = new EventEmitter();




creating_file: number;


  currentUserVAR: any;
  sessionUserId: any;
  sessionUserName: any;
  sessionBrandId: any;
  subject_id: number;
  job_status_run: any;
  subject_notes: any;
  subjects: any;
  public who;

  bsModalRef: BsModalRef;
  // MODAL
  modalRef: BsModalRef;
  subject_com_types: any;

  feature = 'Feature 1';
  selectedFeatures: any = [];
  selectedFeaturesJobFiles: any = [];

  allAttachedFiles: any = [];
  allEmailRecipients: any = [];
  allClientEmailRecipients: any = [];
  allLoginEmailRecipients: any = [];
  allClientInvoiceEmailRecipients: any = [];

  // allAttachments: any[] = [];

  // allAttachments: any[] = [];

  allAttachments = [];
  allRecipients = [];

  // as an angular object / model
  /* allAttachments: any = {
  file_name: 'testfilename.file',
  job_file: 0 ,
  subject_file: 0,
}; */
  empList: Array<any> = [];

  modelds: any;

  public placeholder: String = 'All Recipients';

  // toggle elements
  isShow = true;
  isShow_uploaded = true;

  email_template_directory = this.gfunc.baseUploadURLEmailTemplatesNOHTTP;
  public today = Date.now();
  // variables for richtexteditor as form
  @ViewChild('fromRTE')
  private rteEle: RichTextEditorComponent;

  public tools: object = {
    items: [
      'Undo',
      'Redo',
      '|',
      'Bold',
      'Italic',
      'Underline',
      'StrikeThrough',
      '|',
      'FontName',
      'FontSize',
      'FontColor',
      'BackgroundColor',
      '|',
      'SubScript',
      'SuperScript',
      '|',
      'LowerCase',
      'UpperCase',
      '|',
      'Formats',
      'Alignments',
      '|',
      'OrderedList',
      'UnorderedList',
      '|',
      'Indent',
      'Outdent',
      '|',
      'CreateLink',
      'Image',
      '|',
      'ClearFormat',
      'Print',
      'SourceCode',
      '|',
      'FullScreen',
    ],
  };

  // demo data
  document_types: any[] = [
    {
      document_id: '1',
      document_type_id: '1',
      document_name: 'Process Instructions',
      document_description: '',
      document_template_file: 'template.docx',
      name_file: 'PS_Instructions',
    },
    {
      document_id: '2',
      document_type_id: '1',
      document_name: 'Process Instructions Combined',
      document_description: '',
      document_template_file: 'template.doc',
      name_file: 'PSC_Instructions',
    },
    {
      document_id: '3',
      document_type_id: '1',
      document_name: 'Field Call Instructions',
      document_description: '',
      document_template_file: 'template.doc',
      name_file: 'FC_Instructions',
    },
    {
      document_id: '4',
      document_type_id: '1',
      document_name: 'Field Call Instructions Combined',
      document_description: '',
      document_template_file: 'template.doc',
      name_file: 'FCC_Instructions',
    },
    {
      document_id: '5',
      document_type_id: '1',
      document_name: 'Enforcement Hearing Instructions',
      document_description: '',
      document_template_file: 'template.doc',
      name_file: 'EH_Instructions',
    },
    {
      document_id: '6',
      document_type_id: '1',
      document_name: 'Occupancy Check Intructions',
      document_description: '',
      document_template_file: 'template.doc',
      name_file: 'OC_Instructions',
    },
    {
      document_id: '7',
      document_type_id: '1',
      document_name: 'Lockout Instructions',
      document_description: '',
      document_template_file: 'template.doc',
      name_file: 'Lockout_Instructions',
    },
  ];
  subject_template_docs: any;
  sent_subject_job_type_id: any;
  sent_subject_com_type_id: any;
  model: SubjectCommunication;
  created_file_name: string;
  tableData: any;
  tableSubjectData: any;
  get_latest_subject_note_id: any;
  job_types: any;
  job_subject_types: any;
  job_plaintiff_types: any;
  job_type_locations: any;
  count2: any;
  job_type_courts: any;
  sent_job_type_location_id: any;
  job_type_document_types: any;
  sent_job_type_court_id: any;
  job_type_affidavit_types: any;
  sent_job_type_document_type_id: any;
  doc_check: any = [];
  assignedList: any;
  assignedBrandList: any;

  subjectFullNameOrBusiness: any;

  // iframe
  name = 'Set iframe source';
  url = 'https://angular.io/api/router/RouterLink';
  urlSafe: SafeResourceUrl;
  job_data: any;
  brand_data: any;
  recipient_brand_id: any;
  accounts_brand_id: any;
  brand_account_data: any;
  brand_user_data: any;
  email_template_name: any;
  html_data: string;
  url_non_ssl: string;
  recipient_report_id: any;
  email_template_HTML: any;
  brand_report_id: any;
  brand_invoice_id: any;
  primary_contacts: any;
  filemodel: SystemFile;
  file_created_response: any;
  sessionUserLevel: any;
  system_log_created_response: any;
  file_edit_level: string;
  returned_created_file_id: any;
  subject_invoices: any;
  current_invoice_id: any;
  report_user_contacts: any;
  brand_report_user_id: any;
  DialogObj: any;
  next_date: any;
  final_date: any;
  job_status_id: any;
  legalDatePickerValues: { [field: string]: Date | null } = {};
  message_subject: string;
  set_job_file: number;
  set_subject_file: number;
  allAgentRecipients: any[];
  assignedAgentsList2: any;
  sessionUsername: any;
  sessionUserFullName: string;
  sessionUserFirstName: any;
  client_reference: any;
  cancel_clicked: number;
  click_continue: any;
  set_document_password: string;
  is_encrypted: number;



  constructor(
    private http: HttpClient,
    private _demoService: DemoService,
    private route: ActivatedRoute,
    public toastr: HotToastService,
    vcr: ViewContainerRef,
    private router: Router,

    public HttpClient: HttpClient,
    private fileUploader: FileUploaderService,
    private _mysqlService: MysqlService,
    private modalService: BsModalService,
    private _location: Location,
    public sanitizer: DomSanitizer,
    public gfunc: GlobalFunctionsService,
    public legalDate: LegalDateTimeService
  ) {
  

    this.gfunc.setLoginSessionVars(); // set in a global function file
    this.sessionUserId = this.gfunc.currentUserVAR.user_id;
    this.sessionUsername = this.gfunc.currentUserVAR.username;
    this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;
        this.sessionUserLevel = this.gfunc.currentUserVAR.access_level;
        this.sessionUserFullName = this.gfunc.currentUserVAR.first_name + ' ' + this.gfunc.currentUserVAR.surname;
        this.sessionUserFirstName = this.gfunc.currentUserVAR.first_name;
        this.creating_file = 0; // creating file animation and progress
  }

  ngOnInit() {

    this.filemodel = new SystemFile();

    this.modelds = new SubjectCommunicationAttatchments();
    this.model = new SubjectCommunication();
    this.legalDatePickerValues = {};
    this.model.attached_file_name = '';

    this.subject_id = +this.route.snapshot.paramMap.get('subject_id');
    this.getJobSubject(this.subject_id);
    this.getJobStatusNames();
    this.getSubjectComTypes();

    // agent secrity
    this.getSubjectAgentBrandsAssigned_comms(this.subject_id);

    // popup ask if attatchments
    this.cancel_clicked = 1;
    this.click_continue = 0;

    // testing merging of arrays of files.
    // this.allAttachedFiles  = [...this.selectedFeatures, ...this.selectedFeaturesJobFiles];
  }

  getLegalDatePickerValue(model: any, field: string): Date | null {
    return this.legalDatePickerValues[field] ?? this.legalDate.toPickerDate(model?.[field]);
  }

  onLegalDateChange(model: any, field: string, value: unknown): void {
    const pickerDate = this.legalDate.coercePickerDate(value);
    this.legalDatePickerValues[field] = pickerDate;
    model[field] = this.legalDate.fromPickerDate(pickerDate);
  }

  getJobSubject(subject_id) {
    this._demoService.getJobSubject(subject_id).subscribe(
      (data) => {
        this.subjects = data;
        const res = data[0];
        this.getSubjectNotes(res.subject_id);
        // load subject history
        // this.getSubjectProgress(res.job_id, res.file_number);

        // set the subject name
        if (res.business_name !== '' || res.business_name !== null) {
          this.subjectFullNameOrBusiness = res.business_name;
        }

        if (res.business_name === '' || res.business_name === null) {
          this.subjectFullNameOrBusiness = res.first_name + ' ' + res.surname;
        }

        this.job_id = res.job_id;
        this.subject_number = res.subject_number;

        this.next_date = res.next_date;
        this.final_date = res.final_date;
        this.job_status_id = res.job_status_id;

        this.refreshList(); // loads the file list (diretory)
        this.displaySubjectDocuments(this.subject_id, this.subject_number);

        this.getJobTypeLocations(res.job_type_id);
        this.getJobTypeCourts(res.job_type_location_id);
        this.getJobTypeDocumentTypes(res.job_type_court_id);
        this.getJobTypeAffidavitTypes(res.job_type_document_type_id);
        this.getJobTypes();
        // this.getSubjectAgentBrandsAssigned(this.subject_id);

        // get the job data to get the brand to send to
        this.getJob(this.job_id);
        this.getSubjectInvoices(this.subject_id);



        // get job type in relation to subject
        // this.getJobType(res.job_type_id);
        // this.getJobTypeLocation(res.job_type_location_id);
        // this.getJobTypeCourt(res.job_type_court_id);
        // this.getJobTypeDocument(res.job_type_document_type_id);
        // this.getJobTypeAffidavit(res.job_type_affidavit_type_id)
      },
      (err) => console.error(err)
      // () => console.log('done loading Trace Types')
    );
  }

  getSubjectNotes(subject_id) {
    this._demoService.getSubjectNotes(subject_id).subscribe(
      (data) => {
        this.subject_notes = data;
        // console.log("Done loadng USER");
        // console.log(this.users);
      },
      (error) => {
        //  console.error('Error Loading User!');
        //return console.log(error);
      }
    );
  }

  private getJobStatusNames() {
    this._demoService.getJobStatusNames().subscribe(
      (res) => (this.job_status_run = res),
      (err) => console.error(err.status)
    );
  }

  private getSubjectComTypes() {
    this._demoService.getSubjectComTypes().subscribe(
      (res) => (this.subject_com_types = res),
      (err) => console.error(err.status)
    );
  }

  sendSubjectComTypeID(subject_com_type_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.sent_subject_com_type_id = subject_com_type_id;
    this.getSubjectTemplateDocs(this.sent_subject_com_type_id); // updates the selected job ID....
    console.log(this.sent_subject_com_type_id);
  }

  private getSubjectTemplateDocs(subject_com_type_id) {
    this._demoService.getSubjectTemplateDocs(subject_com_type_id).subscribe(
      (res) => (this.subject_template_docs = res),
      (err) => console.error(err.status)
    );
  }

  subjectView2(subject_id) {
    this.router
      .navigateByUrl('admin/clients', { skipLocationChange: true })
      .then(() =>
        this.router.navigate(['/admin/jobs/subject/edit/' + subject_id + ''])
      );

    // works but does not refresh the page only if set up as a listner.
    // this.router.navigate(['../'  + subject_id], { relativeTo: this.route });
  }

  jobView(job_id) {
    this.router.navigate(['/admin/jobs/view/' + job_id + '']);
  }

  subjectCommunication(subject_id) {
    this.router.navigate([
      '/admin/jobs/subject/communication/' + subject_id + '',
    ]);
  }

  subjectDocuments(subject_id) {
    this.router.navigate(['/admin/jobs/subject/documents/' + subject_id + '']);
  }

  subjectNotesTab(subject_id) {
    this.router.navigate(['/admin/jobs/subject/notes/' + subject_id + '']);
  }

// need to get the file id from the response
  createDocument(model) {
   // this._mysqlService.createDocument(model).subscribe(
    this._mysqlService. createDocument_2021Test(model).subscribe(
   (data) => {
        // this.trace_candidate_update = data;
        this.toastr.success('Creating Document for you now.');
        const res = data;
        // console.log(res); // not working as response is showing in body
        // // console.log(res._body);
        // console.log(res[0].text()); // Convert response to a string
        // this.created_file_name = res[0].text();
        this.created_file_name = res[0] as string;


        model.attached_file_name = this.created_file_name;
        this.refreshList(); // loads the file list (diretory)
        this.displaySubjectDocuments(this.subject_id, this.subject_number);

        this.set_document_password = res[1] as string;
        console.log('set_document_password: ' + this.set_document_password);
  
        if(model.encrypt_file == true){
          this.is_encrypted = 1; //  encrypted
        }else{
          this.is_encrypted = 0; // no encrypted
        }

        // push to global array
        this.allAttachedFiles.push(this.created_file_name);

        // Start the new array of file
        // this.allAttachments.push(this.created_file_name);

        const pushed_file = {
          file_name: this.created_file_name,
          subject_file: 1,
          job_file: 0,
        }; // multidimentional array push
        // this.allAttachments.push(pushed_file); // old way only works for an array.

        // this.empList.push({file_name: this.created_file_name , job_file: 0, subject_file: 1});
        // this.modelds.push({file_name: this.created_file_name , job_file: 0, subject_file: 1});
        this.allAttachments.push({
          file_name: this.created_file_name,
          job_file: 0,
          subject_file: 1,
        });
        model.allAttachments = this.allAttachments; // ?? this may be causing errors.

        // [{name: currencyName, amount: this.ticker[currencyName].last} ]

        // Set the file locations
        // agent

  
      // set the agent permissions
      model.assigned_to_agents = JSON.stringify(this.allAgentRecipients);


      if (model.brand_type_id === '3') {
      this.file_edit_level = '5'; // agent can edit
      //report_access_array ??
      // if an agent the agent has to be the file_brand_id.
      // need to show the agent_id here! name here // model.brand_report_id
    model.brand_report_id = null;
      }
        // client
        if (model.brand_type_id === '2') {
          this.file_edit_level = '3'; // client cannot edit  (staff member can)
        }
  
        const file_server_location = this.gfunc.fileFolderDocs + model.subject_number;
        const file_url = this.gfunc.fileURL + '/' + this.gfunc.fileFolderDocs + model.subject_number + '/' + this.created_file_name;
        const file_folder = this.gfunc.fileFolderDocs + model.subject_number;
        
        // const file_folder = '/APP_PHP/assets/docs/' + model.subject_number;
        const file_name = this.created_file_name.slice(0, -5); // removes the extension
        const random_file_name = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15); // random string
        // UPGRADE Document Model (Insert the File into the database)
        // File Json
        const create_file = {
          file_name: file_name,
          file_display_name: file_name,
          file_ext: 'docx',
          file_server_location: file_server_location,
          file_url: file_url,
          file_folder: file_folder,
          file_make: 'created', // automated / updated / created / uploaded / link_created
          file_notes: 'File created via subject communcation UI',
          file_job_id: this.job_id,
          file_subject_id: this.subject_id,
          file_subject_number: this.subject_number,
          created_by: this.sessionUserId,
          created_date: this.today,
          created_level: this.sessionUserLevel,
          file_brand_id: model.brand_report_id,
          file_access_level: '9', // ? who can access this file and below (client or agent) use brand_type_id
          is_active: '1',
          file_password: this.set_document_password,
          file_edit_level: this.file_edit_level,   // what level of user can edit this file (manager default)
          updated_by: '',
          updated_date: '',
          prev_file_id: '0',    // if updating
          brand_type_id: model.brand_type_id,  // if an agent or a client file
          subject_template_doc_id: model.doc_id,
          subject_com_type_id: model.subject_com_type_id,
          random_file_name: random_file_name,
          full_file_name: this.created_file_name,
          job_id: this.job_id,
          file_number: model.file_number,
          file_reference_number: model.file_reference_number,
          // arrays of sending to - based on subject_template_doc - setup
          agent_access_array: JSON.stringify(this.assignedBrandList), // collect current agent ids
          report_access_array: JSON.stringify(this.brand_data), // collect client
          invoice_access_array: JSON.stringify(this.brand_account_data), // collect client
          user_access_array: JSON.stringify(this.brand_user_data), // of selected associated users.
          is_theme: model.is_theme,
          assigned_to_agents: model.assigned_to_agents,
          is_encrypted: this.is_encrypted
        };
       // console.log( (JSON.stringify(this.assignedBrandList)) );
        this.createFile(create_file);

        // const log_content
        // const log_action
        // Access DOM and get values from HTML template to send to logs
       // const subject_com_type_name = document.getElementsByName('subject_com_type_name');
      // const subject_com_type_name = (<HTMLInputElement>document.getElementById('subject_com_type_name')).value;
      // const subject_com_type_name = (<HTMLElement>document.getElementById('subject_com_type_name'));
      // get the drop down value of text not id.



      },
      (error) => {
        this.toastr.error('Error Creating Document, (if encyption checked) please Check if there must be a Global Company Key set in file recipeint company profile');
       return console.log(error);
      }
    );
  }


// Created to test and process new paragraph templates/merge variables Live without effecting original and current systems and workflows Live.
createDocument_2023_Paragraphs(model, mergeJobData,invoice_id) {
  // generate more data first

  // generate more data first
  this.creating_file = 1; // starts the file creating animation

  this._mysqlService.createDocument_2023_Paragraphs(model).subscribe(
    (data) => {
      // this.trace_candidate_update = data;
      // this.toastr.success('Creating Document for you now.');
      const res = data;
      // console.log(res); // not working as response is showing in body
      // console.log(res._body);
      // console.log('TheRespose: ' + res[0].text()); // Convert response to a string
      this.created_file_name = res[0] as string;
      // this.created_file_name = res[0].text();
      model.attached_file_name = this.created_file_name;

      // generate more data first
      this.creating_file = 0; // ends the file creating animation

      this.refreshList(); // loads the file list (diretory)
      this.displaySubjectDocuments(this.subject_id, this.subject_number);

// october need to fix this here?
        this.set_document_password = res[1] as string;
        console.log('set_document_password: ' + this.set_document_password);

        if(model.encrypt_file == true){
          this.is_encrypted = 1; //  encrypted
        }else{
          this.is_encrypted = 0; // no encrypted
        }

      // push to global array
      this.allAttachedFiles.push(this.created_file_name);

      // Start the new array of file
      // this.allAttachments.push(this.created_file_name); 
      
      
      // set the agent permissions
      model.assigned_to_agents = JSON.stringify(this.allAgentRecipients);

      const pushed_file = {
        file_name: this.created_file_name,
        subject_file: 1,
        job_file: 0,
      }; // multidimentional array push
      // this.allAttachments.push(pushed_file); // old way only works for an array.

      // this.empList.push({file_name: this.created_file_name , job_file: 0, subject_file: 1});
      // this.modelds.push({file_name: this.created_file_name , job_file: 0, subject_file: 1});
      this.allAttachments.push({
        file_name: this.created_file_name,
        job_file: 0,
        subject_file: 1,
      });
      model.allAttachments = this.allAttachments; // ?? this may be causing errors.

      // [{name: currencyName, amount: this.ticker[currencyName].last} ]

      // Set the file locations
      //agent
     
      if (model.brand_type_id === '3') {
      this.file_edit_level = '5'; // agent can edit
      //report_access_array ??
      // if an agent the agent has to be the file_brand_id.
      // need to show the agent_id here! name here // model.brand_report_id
    model.brand_report_id = null;
      }
      //client
      if (model.brand_type_id === '2') {
        this.file_edit_level = '3'; // client cannot edit  (staff member can)
      }

                          const file_server_location = this.gfunc.fileFolderDocs + model.subject_number;
                          const file_url = this.gfunc.fileURL + '/' + this.gfunc.fileFolderDocs + model.subject_number + '/' + this.created_file_name;
                          const file_folder = this.gfunc.fileFolderDocs + model.subject_number;
                          const file_name = this.created_file_name.slice(0, -5); // removes the extension
                          const random_file_name = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15); // random string
                          // UPGRADE Document Model (Insert the File into the database)
                          // File Json
                          const create_file = {
                            file_name: file_name,
                            file_display_name: file_name,
                            file_ext: 'docx',
                            file_server_location: file_server_location,
                            file_url: file_url,
                            file_folder: file_folder,
                            file_make: 'created', // automated / updated / created / uploaded / link_created
                            file_notes: 'File created via subject communcation UI',
                            file_job_id: this.job_id,
                            file_subject_id: this.subject_id,
                            file_subject_number: this.subject_number,
                            created_by: this.sessionUserId,
                            created_date: this.today,
                            created_level: this.sessionUserLevel,
                            file_brand_id: model.brand_report_id,
                            file_access_level: '9', // ? who can access this file and below (client or agent) use brand_type_id
                            is_active: '1',
                            file_password: this.set_document_password,
                            file_edit_level: this.file_edit_level,   // what level of user can edit this file (manager default)
                            updated_by: '',
                            updated_date: '',
                            prev_file_id: '0',    // if updating
                            brand_type_id: model.brand_type_id,  // if an agent or a client file
                            subject_template_doc_id: model.doc_id,
                            subject_com_type_id: model.subject_com_type_id,
                            random_file_name: random_file_name,
                            full_file_name: this.created_file_name,
                            job_id: this.job_id,
                            file_number: model.file_number,
                            file_reference_number: model.file_reference_number,
                            // arrays of sending to - based on subject_template_doc - setup
                            agent_access_array: JSON.stringify(this.assignedBrandList), // collect current agent ids
                            report_access_array: JSON.stringify(this.brand_data), // collect client
                            invoice_access_array: JSON.stringify(this.brand_account_data), // collect client
                            user_access_array: JSON.stringify(this.brand_user_data), // of selected associated users.
                            is_theme: model.is_theme,
                            assigned_to_agents:  model.assigned_to_agents,  // set the agent permissions
                            is_encrypted: this.is_encrypted
                          };
                         // console.log( (JSON.stringify(this.assignedBrandList)) );
                          this.createFile(create_file);

      // const log_content 
      // const log_action
      // Access DOM and get values from HTML template to send to logs
     // const subject_com_type_name = document.getElementsByName('subject_com_type_name');
    // const subject_com_type_name = (<HTMLInputElement>document.getElementById('subject_com_type_name')).value; 
    // const subject_com_type_name = (<HTMLElement>document.getElementById('subject_com_type_name'));
    // get the drop down value of text not id.



    },
    (error) => {
      // this.toastr.error('Error Creating Document');
            // console.log('there was an error' + JSON.stringify(error));
            // console.log('TextError.error: = ' + JSON.stringify(error.error.text));
            // this.created_file_name = error.error.text
      this.newCreatedFile(model, this.created_file_name);
    //  return error.error;
    },
     () => console.log('What do we do next..????' + this.created_file_name)
  );
}


// new with re response code being an error but returns and creatd the file... go fugure.???
newCreatedFile(model, created_file_name){


  model.attached_file_name = this.created_file_name;
  this.refreshList(); // loads the file list (diretory)
  this.displaySubjectDocuments(this.subject_id, this.subject_number);

  // push to global array
  this.allAttachedFiles.push(this.created_file_name);

  // Start the new array of file
  // this.allAttachments.push(this.created_file_name); 
  
  
  // set the agent permissions
  model.assigned_to_agents = JSON.stringify(this.allAgentRecipients);

  const pushed_file = {
    file_name: this.created_file_name,
    subject_file: 1,
    job_file: 0,
  }; // multidimentional array push
  // this.allAttachments.push(pushed_file); // old way only works for an array.

  // this.empList.push({file_name: this.created_file_name , job_file: 0, subject_file: 1});
  // this.modelds.push({file_name: this.created_file_name , job_file: 0, subject_file: 1});
  this.allAttachments.push({
    file_name: this.created_file_name,
    job_file: 0,
    subject_file: 1,
  });
  model.allAttachments = this.allAttachments; // ?? this may be causing errors.

  // [{name: currencyName, amount: this.ticker[currencyName].last} ]

  // Set the file locations
  //agent
 
  if (model.brand_type_id === '3') {
  this.file_edit_level = '5'; // agent can edit
  }
  //client
  if (model.brand_type_id === '2') {
    this.file_edit_level = '3'; // client cannot edit  (staff member can)
  }

                      const file_server_location = this.gfunc.fileFolderDocs + model.subject_number;
                      const file_url = this.gfunc.fileURL + '/' + this.gfunc.fileFolderDocs + model.subject_number + '/' + this.created_file_name;
                      const file_folder = this.gfunc.fileFolderDocs + model.subject_number;
                      const file_name = this.created_file_name.slice(0, -5); // removes the extension
                      const random_file_name = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15); // random string
                      // UPGRADE Document Model (Insert the File into the database)
                      // File Json
                      const create_file = {
                        file_name: file_name,
                        file_display_name: file_name,
                        file_ext: 'docx',
                        file_server_location: file_server_location,
                        file_url: file_url,
                        file_folder: file_folder,
                        file_make: 'created', // automated / updated / created / uploaded / link_created
                        file_notes: 'File created via subject communcation UI',
                        file_job_id: this.job_id,
                        file_subject_id: this.subject_id,
                        file_subject_number: this.subject_number,
                        created_by: this.sessionUserId,
                        created_date: this.today,
                        created_level: this.sessionUserLevel,
                        file_brand_id: model.brand_report_id,
                        file_access_level: '9', // ? who can access this file and below (client or agent) use brand_type_id
                        is_active: '1',
                        file_password: '',
                        file_edit_level: this.file_edit_level,   // what level of user can edit this file (manager default)
                        updated_by: '',
                        updated_date: '',
                        prev_file_id: '0',    // if updating
                        brand_type_id: model.brand_type_id,  // if an agent or a client file
                        subject_template_doc_id: model.doc_id,
                        subject_com_type_id: model.subject_com_type_id,
                        random_file_name: random_file_name,
                        full_file_name: this.created_file_name,
                        job_id: this.job_id,
                        file_number: model.file_number,
                        file_reference_number: model.file_reference_number,
                        // arrays of sending to - based on subject_template_doc - setup
                        agent_access_array: JSON.stringify(this.assignedBrandList), // collect current agent ids
                        report_access_array: JSON.stringify(this.brand_data), // collect client
                        invoice_access_array: JSON.stringify(this.brand_account_data), // collect client
                        user_access_array: JSON.stringify(this.brand_user_data), // of selected associated users.
                        is_theme: model.is_theme,
                        assigned_to_agents:  model.assigned_to_agents  // set the agent permissions
                      };
                     // console.log( (JSON.stringify(this.assignedBrandList)) );
                      this.createFile(create_file);
}






  sendAgentInstructEmail(model) {

  //.. set cancel clicked if there is attachments so functions below can run.
          if(this.allAttachments.length >= 1){
          this.cancel_clicked = 0;
          }else if(this.allAttachments.length <= 0 && this.click_continue >= 1){
          this.cancel_clicked = 0;
          }   
          else{
          this.cancel_clicked = 1;
          // return;
          };



          if( this.cancel_clicked == 1){
          this.onOpenDialogSendComms(model, model); // need to restructure the comms to ask the question.
          return;
          }






    // model.attached_file_name = this.created_file_name;
    model.attached_file_names = this.selectedFeatures;
    model.attached_job_file_names = this.selectedFeaturesJobFiles;
    model.all_attached_file_names = this.allAttachedFiles;
    model.allAttachments = this.allAttachments;
    model.allRecipients = this.allRecipients;
    console.log(model.attached_file_names);

    this.model.allAttachments = this.allAttachments;
    this.model.allRecipients = this.allRecipients;

    this.createSubjectNote(model); // Insert a Note to the subject
    this.subjectChangeDates(model, this.subject_id); // moved to update before meail.

    
    const subject_com_type_name = (<HTMLSelectElement>document.getElementById('subject_com_type_id')).selectedOptions[0].text;
    console.log('Communication Type Task: ' +  subject_com_type_name);
        //  const subject_com_type_name = document.getElementById('subject_com_type_name').innerText;
         //  console.log('Communication Type Task: ' +  subject_com_type_name);
   const doc_name = document.getElementById('doc_name').innerText;
   console.log('Document Name: ' +  doc_name);

     // set the invoice from the list of invoices (first record)
  if (model.invoice_id == null) {
    model.invoice_id = this.current_invoice_id;
  }

  const subject_communication_history = {
    job_id: model.job_id,
    subject_id: model.subject_id,
    subject_com_type_id: model.subject_com_type_id,
    doc_id: model.doc_id,
    change_dates: model.change_dates,
    additional_message: model.additional_message,
    brand_type_id: model.brand_type_id,
    brand_id: model.brand_id,
    all_attached_file_names: JSON.stringify(model.all_attached_file_names),
    send_to_invoice: model.send_to_invoice,
    send_to_report: model.send_to_report,
    send_to_logins: model.send_to_logins,
    send_to_primary: model.send_to_primary,
    allAttachments: JSON.stringify(model.allAttachments),
    allRecipients: JSON.stringify(model.allRecipients),
    allAttachedFiles: JSON.stringify(model.allAttachedFiles),
    brand_report_id: model.brand_report_id,
    brand_invoice_id: model.brand_invoice_id,
    job_type_name: model.job_type_name,
    job_type_location_name: model.job_type_location_name,
    brand_report_user_id: model.brand_report_user_id,
    email_message_subject: model.email_message_subject,
    email_message_recipeints: JSON.stringify(model.email_message_recipeints),
    message_subject: model.message_subject,
    recipient_name: model.recipient_name,
    recipient_type_name: model.recipient_type_name,
    recipient_email_address: JSON.stringify(model.recipient_email_address),
    email_template_HTML: model.email_template_HTML,
    subject_number: model.subject_number,
    created_by: this.sessionUserId,
    created_date: this.today,
    attached_file_names: JSON.stringify(model.attached_file_names),
    attached_job_file_names: JSON.stringify(model.attached_job_file_names),
    subject_com_type_name: model.subject_com_type_name
  };
  this.gfunc.createSubjectCommunicationHistory(subject_communication_history);

  
    const log_action = 'sent';
    const log_name = 'Subject Communicaiton Task: ' + subject_com_type_name  + ' - ' + doc_name + ' -  Emailed';
    const create_sys_log = {
      log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
      log_action: log_action, // automated / updated / created / uploaded / link_created / sent
      created_by: this.sessionUserId,
      created_date: this.today,
      subject_id: this.subject_id,
      job_id: this.job_id,
      job_reference_number: model.job_reference_number,
      file_number: model.file_subject_number,
      reference_number: model.job_reference_number,
      subject_number: model.subject_number,
      log_type_id: '2', // see datatable system_log_types se (2 when a file is sent with an email)
      created_level: this.sessionUserLevel,
      brand_type_id: model.brand_type_id,
      subject_com_type_id: model.subject_com_type_id,
      subject_template_doc_id: model.doc_id,
      log_name: log_name + ' - ' + this.returned_created_file_id,
      file_id: this.returned_created_file_id,
      invoice_id: model.invoice_id,
    };
    this.createSystemLog(create_sys_log);


    this._mysqlService.sendAgentInstructEmail(model).subscribe(
      (data) => {
        // this.trace_candidate_update = data;
        this.toastr.success('Sent Email.');
        const res = data;
        // console.log(res); // not working as response is showing in body
        // // console.log(res._body);
        // console.log(res[0].text()); // Convert response to a string
        this.created_file_name = res[0] as string;

        this.subjectChangeDates(model, this.subject_id);
        this.gfunc.onOpenDialog_SuccessCommunication(event, model);
      },
      (error) => {
        // this.toastr.error('Error sending Email');
               // Run this anyway ....
               this.toastr.success(' ðŸ‘“ Sent Email & Communications Success.');
               this.gfunc.onOpenDialog_SuccessCommunication(event, model);
       return console.log(error);
      }
    );
  }

  // this function is universal for client or email now.
  sendAgentCommunicationEmail(model) {


// console.log('cancel_clicked: ' + this.cancel_clicked)
// console.log('allAttachment.length:  ' + this.allAttachments.length)
// console.log('continue_clicked: ' + this.click_continue)



  //.. set cancel clicked if there is attachments so functions below can run.
  if(this.allAttachments.length >= 1){
    this.cancel_clicked = 0;
  }else if(this.allAttachments.length <= 0 && this.click_continue >= 1){
    this.cancel_clicked = 0;
  }   
  else{
        this.cancel_clicked = 1;
       // return;
    }

      // console.log('cancel_clicked Second: ' + this.cancel_clicked)
      // console.log('allAttachment.length:  ' + this.allAttachments.length)
      // console.log('continue_clicked_second: ' + this.click_continue)


  //     // if no attachemnts ask the question
    // this function will do a check if the variable "cancel_clicked has not also been checked already... infinate loop."
              // if(this.allAttachments.length <= 0 || this.cancel_clicked == 1 || this.cancel_clicked == undefined){
              // this.onOpenDialogSendComms(model, model); // need to restructure the comms to ask the question.
              // return;
              //   }



              // || this.cancel_clicked == undefined
      // this function will do a check if the variable "cancel_clicked has not also been checked already... to stop infinate loop."
      if( this.cancel_clicked == 1){
        this.onOpenDialogSendComms(model, model); // need to restructure the comms to ask the question.
        return;
      }
    


  // if(this.cancel_clicked == 0){
    // model.attached_file_name = this.created_file_name;
    model.attached_file_names = this.selectedFeatures;
    model.attached_job_file_names = this.selectedFeaturesJobFiles;
    model.all_attached_file_names = this.allAttachedFiles;
    model.allAttachments = this.allAttachments;
    model.allRecipients = this.allRecipients;
    console.log(model.attached_file_names);

    // set the default viweing client as the reporting cleint (switch to invoice client if an invoice.)
    if (model.invoice_id > 0) {
      model.brand_id = model.brand_invoice_id;
    }else {
      model.brand_id = model.brand_report_id;
    }

    this.model.allAttachments = this.allAttachments;
    this.model.allRecipients = this.allRecipients;

    this.createSubjectNote(model); // Insert a Note to the subject
    this.subjectChangeDates(model, this.subject_id); // moved to update before meail.

    const subject_com_type_name = (<HTMLSelectElement>document.getElementById('subject_com_type_id')).selectedOptions[0].text;
    console.log('Communication Type Task: ' +  subject_com_type_name);
        //  const subject_com_type_name = document.getElementById('subject_com_type_name').innerText;
         //  console.log('Communication Type Task: ' +  subject_com_type_name);
   const doc_name = document.getElementById('doc_name').innerText;
   console.log('Document Name: ' +  doc_name);

     // set the invoice from the list of invoices (first record)
  if (model.invoice_id == null) {
    model.invoice_id = this.current_invoice_id;
  }

  const subject_communication_history = {
    job_id: model.job_id,
    subject_id: model.subject_id,
    subject_com_type_id: model.subject_com_type_id,
    doc_id: model.doc_id,
    change_dates: model.change_dates,
    additional_message: model.additional_message,
    brand_type_id: model.brand_type_id,
    brand_id: model.brand_id,
    all_attached_file_names: JSON.stringify(model.all_attached_file_names),
    send_to_invoice: model.send_to_invoice,
    send_to_report: model.send_to_report,
    send_to_logins: model.send_to_logins,
    send_to_primary: model.send_to_primary,
    allAttachments: JSON.stringify(model.allAttachments),
    allRecipients: JSON.stringify(model.allRecipients),
    allAttachedFiles: JSON.stringify(model.allAttachedFiles),
    brand_report_id: model.brand_report_id,
    brand_invoice_id: model.brand_invoice_id,
    job_type_name: model.job_type_name,
    job_type_location_name: model.job_type_location_name,
    brand_report_user_id: model.brand_report_user_id,
    email_message_subject: model.email_message_subject,
    email_message_recipeints: JSON.stringify(model.email_message_recipeints),
    message_subject: model.message_subject,
    recipient_name: model.recipient_name,
    recipient_type_name: model.recipient_type_name,
    recipient_email_address: JSON.stringify(model.recipient_email_address),
    email_template_HTML: model.email_template_HTML,
    subject_number: model.subject_number,
    created_by: this.sessionUserId,
    created_date: this.today,
    attached_file_names: JSON.stringify(model.attached_file_names),
    attached_job_file_names: JSON.stringify(model.attached_job_file_names),
    subject_com_type_name: model.subject_com_type_name
  };
  this.gfunc.createSubjectCommunicationHistory(subject_communication_history);

  
    const log_action = 'sent';
    const log_name = 'Subject Communicaiton Task: ' + subject_com_type_name  + ' - ' + doc_name + ' -  Emailed';
    const create_sys_log = {
      log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
      log_action: log_action, // automated / updated / created / uploaded / link_created / sent
      created_by: this.sessionUserId,
      created_date: this.today,
      subject_id: this.subject_id,
      job_id: this.job_id,
      job_reference_number: model.job_reference_number,
      file_number: model.file_subject_number,
      reference_number: model.job_reference_number,
      subject_number: model.subject_number,
      log_type_id: '2', // see datatable system_log_types se (2 when a file is sent with an email)
      created_level: this.sessionUserLevel,
      brand_type_id: model.brand_type_id,
      subject_com_type_id: model.subject_com_type_id,
      subject_template_doc_id: model.doc_id,
      log_name: log_name + ' - ' + this.returned_created_file_id,
      file_id: this.returned_created_file_id,
      invoice_id: model.invoice_id,
      brand_id: model.brand_id
    };
    this.createSystemLog(create_sys_log);

            // Update invoice status
        // :: @ Update the Invoice Status to Approved+PDF (4)
        let invoice_model = {
          invoice_id: model.invoice_id,
          invoice_communication_status_id: 2,
            };
          this.updateInvoiceCommunicationStatus(invoice_model);  // moved to top.

    this._mysqlService.sendAgentCommunicationEmail(model).subscribe(
      (data) => {
        // this.trace_candidate_update = data;
        this.toastr.success(' ðŸ‘“ Sent Email & Communications Success.');
        const res = data;
        console.log(res); // not working as response is showing in body
        // console.log(res._body);
        // console.log(res[0].text()); // Convert response to a string

        // this.subjectChangeDates(model, this.subject_id); // moved to to run before email send.
        // now global success function
        this.gfunc.onOpenDialog_SuccessCommunication(event, model);

        // now close the modal
        this.closeParentModel.emit();
        this.closeParentModel3.emit();
        // refresh the invoice page if
        if ( model.invoice_id > 0 ) {
          this.refreshSujectInvoicePage.emit(this.subject_id);
        }
      },
      (error) => {
        // this.toastr.error('Error sending Email');
        // Run this anyway ....
        this.toastr.success(' ðŸ‘“ Sent Email & Communications Success.');
        this.gfunc.onOpenDialog_SuccessCommunication(event, model);
        return console.log(error);
      }
    );

    // } // end if cancel clicked


  }

  // this function is universal for client or email now.
  sendAffidavitCommunicationEmail(model) {
  
    //.. set cancel clicked if there is attachments so functions below can run.
    if(this.allAttachments.length >= 1){
      this.cancel_clicked = 0;
      }else if(this.allAttachments.length <= 0 && this.click_continue >= 1){
      this.cancel_clicked = 0;
      }   
      else{
      this.cancel_clicked = 1;
      // return;
      };



      if( this.cancel_clicked == 1){
      this.onOpenDialogSendComms(model, model); // need to restructure the comms to ask the question.
      return;
      }
  
  
  
    // model.attached_file_name = this.created_file_name;
    model.attached_file_names = this.selectedFeatures;
    model.attached_job_file_names = this.selectedFeaturesJobFiles;
    model.all_attached_file_names = this.allAttachedFiles;
    model.allAttachments = this.allAttachments;
    model.allRecipients = this.allRecipients;
    console.log(model.attached_file_names);

    this.createSubjectNote(model); // Insert a Note to the subject
    this.subjectChangeDates(model, this.subject_id); // moved to update before meail.

    this.model.allAttachments = this.allAttachments;
    this.model.allRecipients = this.allRecipients;

    this._mysqlService.sendAffidavitCommunicationEmail(model).subscribe(
      (data) => {
        // this.trace_candidate_update = data;
        this.toastr.success('Sent Email.');
        const res = data;
        console.log(res); // not working as response is showing in body
        // console.log(res._body);
        console.log(res[0].text()); // Convert response to a string
        this.subjectChangeDates(model, this.subject_id);
        this.gfunc.onOpenDialog_SuccessCommunication(event, model);
      },
      (error) => {
        // this.toastr.error('Error sending Email');
        // Run this anyway ....
        this.toastr.success(' ðŸ‘“ Sent Email & Communications Success.');
        this.gfunc.onOpenDialog_SuccessCommunication(event, model);
       return console.log(error);
      }
    );
  }

  sendClientAttServEmail(model) {
    // model.attached_file_name = this.created_file_name;
    model.attached_file_names = this.selectedFeatures;
    model.attached_job_file_names = this.selectedFeaturesJobFiles;
    model.allAttachments = this.allAttachments;
    model.allRecipients = this.allRecipients;
    console.log(model.attached_file_names);

    this.createSubjectNote(model); // Insert a Note to the subject

    this._mysqlService.sendClientAttServ(model).subscribe(
      (data) => {
        // this.trace_candidate_update = data;
        this.toastr.success('Sent Email.');
        const res = data;
        console.log(res); // not working as response is showing in body
        // console.log(res._body);
        console.log(res[0].text()); // Convert response to a string
      },
      (error) => {
        // this.toastr.error('Error sending Email');
                // Run this anyway ....
                this.toastr.success(' ðŸ‘“ Sent Email & Communications Success.');
                this.gfunc.onOpenDialog_SuccessCommunication(event, model);
       return console.log(error);
      }
    );
  }

  private refreshList(): void {
    // notice the update here for traces
    this.fileUploader
      .getJobFiles(this.job_id)
      .subscribe((res) => this.displayTableData(res));
  }
  job_id(job_id: any): any {
    throw new Error('Method not implemented.');
  }

  displaySubjectDocuments(subject_id, subject_number) {
    this.fileUploader
      .getJobSubjectFiles(this.subject_id, this.subject_number)
      .subscribe((res) => this.displaySubjectFiles(res));
  }
  subject_number(subject_id: number, subject_number: any): any {
    throw new Error('Method not implemented.');
  }

  private displayTableData(data: any): void {
    // this.tableData = data.json();
    this.tableData = data;
  }

  private displaySubjectFiles(data: any): void {
    // this.tableSubjectData = data.json();
    this.tableSubjectData = data;
  }

  attachFile(filename, job_id) {
    if (confirm('Are you sure you want to Attatch this file? ')) {
      /*
        this._mysqlService.deleteJobFile('nothing', job_id).subscribe(
           data => {
             // this.getTraceNotes(this.trace_id);
            this.refreshList();
             return true;
           },
           error => {
             console.error('Error deleting Job File!');
            return console.log(error);
           }
        );*/

      this.model.attached_file_names = filename;

      console.log(filename);
    }
  }

  attachJobFile(filename, job_id) {
    if (confirm('Are you sure you want to Attatch this file? ')) {
      /*
        this._mysqlService.deleteJobFile('nothing', job_id).subscribe(
           data => {
             // this.getTraceNotes(this.trace_id);
            this.refreshList();
             return true;
           },
           error => {
             console.error('Error deleting Job File!');
            return console.log(error);
           }
        );*/

      this.model.attached_job_file_names = filename;
      // console.log(filename);
    }
  }

  deleteJobFile(filename, job_id) {
    if (confirm('Are you sure you want to delete this file? ')) {
      this._mysqlService.deleteJobFile(filename, job_id).subscribe(
        (data) => {
          // this.getTraceNotes(this.trace_id);
          this.refreshList();
          return true;
        },
        (error) => {
          console.error('Error deleting Job File!');
         return console.log(error);
        }
      );
    }
  }


  



  onAdd(data) {
    if (confirm('Are you sure you want to Attatch this file? ')) {
     // this.selectedFeatures.push(fileName);
      // push to global array
  
  console.log('Send Subject ID: ' + data.file_subject_id + ' JObID: ' + data.file_job_id);
  
      if (data.file_subject_id  >= 1) {
        this.set_job_file = 0;
        this.set_subject_file = 1;
      }
  
      if (data.file_subject_id  <= 0) {
        this.set_job_file = 1;
        this.set_subject_file = 0;
      }
  
      this.allAttachedFiles.push(data.fileName);
      this.allAttachments.push({
        file_name: data.full_file_name,
        job_file: this.set_job_file,
        subject_file: this.set_subject_file,
        subject_number: data.subject_number,
        job_id: data.job_id,
        file_server_location: data.file_server_location
      });
  
  this.allAttachedFiles = this.allAttachedFiles;
  this.model.allAttachedFiles = this.allAttachedFiles;
  this.model.allAttachments = this.allAttachments;
  
  // this.toastr.success('Attatchment added.');
     // this.isShow = !this.isShow; // hides the div again
      // this.isShow_uploaded = !this.isShow_uploaded;
  
      // closes the model when opened from file browser.
      this.modalRef.hide();
    }
  }


  // onAdd(fileName) {
  //   if (confirm('Are you sure you want to Attatch this file? ')) {
  //     this.selectedFeatures.push(fileName);
  //     // push to global array
  //     this.allAttachedFiles.push(fileName);
  //     this.allAttachments.push({
  //       file_name: fileName,
  //       job_file: 0,
  //       subject_file: 1,
  //     });

  //     this.toastr.success('Attatchment added.');
  //     this.isShow = !this.isShow; // hides the div again
  //     // this.isShow_uploaded = !this.isShow_uploaded;

  //     // closes the model when opened from file browser.
  //     this.closeParentModelDefault(fileName);
  //   }
  // }

  onAddJobFile(fileName) {
    if (confirm('Are you sure you want to Attatch this file? ')) {
      this.selectedFeaturesJobFiles.push(fileName);
      // push to global array
      this.allAttachedFiles.push(fileName);
      this.allAttachments.push({
        file_name: fileName,
        job_file: 1,
        subject_file: 0,
      });
      this.toastr.success('Attatchment added.');
      // this.isShow = !this.isShow; // hides the div again
      this.isShow_uploaded = !this.isShow_uploaded;
    }
  }

  onRemoveJobFile() {
    this.selectedFeaturesJobFiles.pop();
    this.toastr.warning('Attatchment removed.');
  }

  onRemoveAllFile() {
    this.allAttachedFiles.pop();
    this.toastr.warning('Attatchment removed.');
    // this.allAttachments.pop();
  }

  onRemove() {
    this.selectedFeatures.pop();
    this.toastr.warning('Attatchment removed.');
  }

  // toggle elements
  toggleDisplay() {
    this.isShow = !this.isShow;
  }

  toggleDisplayUploaded() {
    this.isShow_uploaded = !this.isShow_uploaded;
  }

  // Create New Type of note:
  createSubjectNote(model) {
    // this.sendEmail(this.job_id, this.subject_id, this.sessionUserId, model);
    model.created_by = this.sessionUserId;
    model.note_content =
      'Instruct request emailed to the agent. Manual From Subject Card Screen.';
    model.note_type_id = '1';



// need to check if this effects the others on insert
// this.RemoveElementOthersFromAllRecipients(model.subject_id);
// currentlu saves all the recipients into the array and filters out at read
 model.assigned_to_agents = JSON.stringify(this.allRecipients);
console.log('model.assigned_to_agents: ', model.assigned_to_agents);

    // if (result.job_status === 'OPEN'){
                this._demoService.createSubjectNote(model).subscribe(
                  (data) => {
                    this.get_latest_subject_note_id = data; // this is the retuned json upon creation.
                    this.toastr.info('Note Added');
                    // const objIndex = this.search_results.findIndex((obj => obj.subject_id === result.subject_id));
                    // this.search_results[objIndex].note_added = 'yes';
                  },
                  (error) => {
                    // console.log(error(error));
                    //return console.log(error);
                  }
                );
    // } // end if  open
  }


  RemoveElementOthersFromAllRecipients(key: number) {
    // test! -- load again an then filter and create the array again.
    // this.getSubjectAgentBrandsAssigned2(this.subject_id); // load first then remove. safest option.
  
    // delay load slightly so I can refresh the allRecpientList first.
    setTimeout(function() {   
  }, 2000);
      console.log("Ready to clean array!")
  
    let array = this.allRecipients;
    // removes all not matching
      // :: Specifcally removes the array item without there being
      // :: @https://stackoverflow.com/questions/5767325/how-can-i-remove-a-specific-item-from-an-array
      this.allRecipients.forEach((value, index) => {
      if (value.recipient_brand_id !== key) {
        this.allRecipients.splice(index, 1);
      }
    });
    console.log('allRecipients after Removal Others: ', JSON.stringify(this.allRecipients));
  
  // ::@https://stackoverflow.com/questions/5310304/remove-json-element
  // let json = this.allRecipients
  // let id_key = "recipient_brand_id";
  // delete json[id_key]; // Removes json.foo from the dictionary.
  
  
  
  };




  // BOF SHARMANS CALLS
  getJobTypes() {
    this._demoService.getJobTypes().subscribe(
      (data) => {
        this.job_types = data;
      },
      (err) => console.error(err)
      // () => console.log('done loading Trace Types')
    );
  }

  getJobSubjectTypes() {
    this._demoService.getJobSubjectTypes().subscribe(
      (data) => {
        this.job_subject_types = data;
      },
      (err) => console.error(err)
      // () => console.log('done loading Trace Types')
    );
  }

  getJobPlaintiffTypes() {
    this._demoService.getJobPlaintiffTypes().subscribe(
      (data) => {
        this.job_plaintiff_types = data;
      },
      (err) => console.error(err)
      // () => console.log('done loading Trace Types')
    );
  }

  getJobTypeLocations(job_type_id) {
    this._demoService.getJobTypeLocations(job_type_id).subscribe(
      (data) => {
        this.job_type_locations = data;
      },
      (err) => console.error(err)
      // () => console.log('done loading Trace Types')
    );
  }

  sendJobTypeLocationsID(job_type_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.count2 = job_type_id;
    this.getJobTypeLocations(this.count2); // updates the selected job ID....

    console.log('sending Count:' + this.count2);
  }

  getJobTypeCourts(job_type_location_id) {
    this._demoService.getJobTypeCourts(job_type_location_id).subscribe(
      (data) => {
        this.job_type_courts = data;
      },
      (err) => console.error(err)
      // () => console.log('done loading Trace Types')
    );
  }

  sendJobTypeCourtsID(job_type_location_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.sent_job_type_location_id = job_type_location_id;
    this.getJobTypeCourts(this.sent_job_type_location_id); // updates the selected job ID....

    console.log('sending Location:' + this.sent_job_type_location_id);
  }

  getJobTypeDocumentTypes(job_type_court_id) {
    this._demoService.getJobTypeDocumentTypes(job_type_court_id).subscribe(
      (data) => {
        this.job_type_document_types = data;
      },
      (err) => console.error(err)
      // () => console.log('done loading Trace Types')
    );
  }

  sendJobTypeDocumentTypesID(job_type_court_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.sent_job_type_court_id = job_type_court_id;
    this.getJobTypeDocumentTypes(this.sent_job_type_court_id); // updates the selected job ID....

    console.log('sending Court Type:' + this.sent_job_type_court_id);
  }

  getJobTypeAffidavitTypes(job_type_document_type_id) {
    this._demoService
      .getJobTypeAffidavitTypes(job_type_document_type_id)
      .subscribe(
        (data) => {
          this.job_type_affidavit_types = data;
        },
        (err) => console.error(err)
        // () => console.log('done loading Trace Types')
      );
  }

  sendJobTypeAffidavitTypesID(job_type_document_type_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.sent_job_type_document_type_id = job_type_document_type_id;
    this.getJobTypeAffidavitTypes(this.sent_job_type_document_type_id); // updates the selected job ID....

    console.log('sending Doc Type:' + this.sent_job_type_document_type_id);
  }

  getSubjectTemplateDocsCheck(model) {
    this._demoService.getSubjectTemplateDocsCheck(model).subscribe(
      (data) => {
        {
          this.doc_check = data;
          const res = data[0];
          // set the model document id to the new one affidavits.
          model.doc_id = res.doc_id; // does this need to be this.???
          // set the recipeint type for display
          model.brand_type_id = res.brand_type_id;

          this.email_template_name = res.email_template;
          this.email_template_HTML = res.email_template_HTML;
          model.email_template_HTML = res.email_template_HTML;
          model.send_to_invoice = res.send_to_invoice;
          model.send_to_report = res.send_to_report;
          model.send_to_logins = res.send_to_logins;
          model.send_to_primary = res.send_to_primary;
          model.brand_type_id = res.brand_type_id;
          model.send_to_report_user = res.send_to_report_user;

          // load the recipients into an array
          this.getSubjectAgentBrandsAssigned(this.subject_id);
          // load brands - clients into array
          this.getBrand(this.recipient_report_id);
          this.getBrandUsers(this.recipient_report_id);
          this.getBrandAccount(this.accounts_brand_id);

          model.brand_report_id = this.brand_report_id;
          model.brand_invoice_id = this.brand_invoice_id;
          model.brand_report_user_id = this.brand_report_user_id;

          // had to set here to sho
          model.subject_id = this.subject_id;

          model.change_dates = '1'; // set to default to system dates changes
          this.created_file_name = null; // reset the file to be recreated on change
            
          // Setup Recipients :: New 2022 Model allRecipients
          this.setAllRecipients(model);

          // :: Set the Message Subject Default Title
          // tslint:disable-next-line:max-line-length

          // TODO: Make so that only client communications have this . - subject_com_type_id?

          // this.message_subject = 'Subject: ' +  res.email_subject_header + ' ' + this.subjectFullNameOrBusiness + ' Our Reference: '  + this.subject_number;
          this.message_subject = 'Subject: ' +  res.email_subject_header + ' Our Reference: '  + this.subject_number;
         
          if(model.subject_com_type_id == 3){
            // this.message_subject = 'Reference: ' + this.client_reference + ', ' + 'Subject: ' +  res.email_subject_header + ' ' + this.subjectFullNameOrBusiness + ' Our Reference: '  + this.subject_number;
            this.message_subject = 'Reference: ' + this.client_reference + ', ' +  res.email_subject_header + ' Our Reference: '  + this.subject_number;
          }


         
          model.message_subject = this.message_subject;

          this.url =
          this.gfunc.baseUploadURLEmailTemplatesSSL +
            this.email_template_name;
          this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(
            this.url
          );


      // upgrade for attempts paragraphs checker == if 1 then accept. otherwise warn
      // 2.3.1.1
      model.attempt_paragraph_template = res.attempt_paragraph_template;

        }
      },
      (err) => console.error(err)
      // () => console.log('done loading Trace Types')
    );
  }

  // to router navigate back
  public goBack() {
    this._location.back();
  }

  docView(doc_id) {
    this.router.navigate([
      '/admin/communication/com_type_template_doc_view/' + doc_id + '',
    ]);
  }

  docEdit(doc_id) {
    this.router.navigate([
      '/admin/communication/com_type_template_doc_edit/' + doc_id + '',
    ]);
  }


  docEditSubjectFile(file_id) {
    this.router.navigate(['/admin/jobs/subject/communication/docx-view/' + file_id + '']);
  }

  docViewSubjectFile(file_id) {
    this.router.navigate(['/admin/jobs/subject/communication/docx-view/' + file_id + '']);
  }

  viewSystemFile(file_id) {
    this.router.navigate(['/admin/system-file-manager/system-file/' + file_id + '']);
  }

  editSystemFile(file_id) {
    this.router.navigate(['/admin/system-file-manager/system-file-edit/' + file_id + '']);
  }

  editDocFile(file_id) {
    this.router.navigate(['/admin/system-file-manager/system-doc-edit/' + file_id + '']);
  }


  editDocxSystemFile(file_id) {
    this.gfunc.globalEditDocxSystemFile(file_id);
    // this.router.navigate(['/admin/system-file-manager/system-doc-edit/docx-edit/' + file_id + '']);
  }

  

  viewDocxSystemFile(file_id) {
    this.gfunc.globalViewDocxSystemFile(file_id);
    // this.router.navigate(['/admin/system-file-manager/system-doc-edit/docx-view/' + file_id + '']);
  }



  // testing some jquery
  Testing() {
    const name = (
      document.getElementById('subject_com_type_id') as HTMLTextAreaElement
    ).value;
    alert(name);

    // get the option name of the select Works so can use when adding as a fix.
    const conceptName = $('#subject_com_type_id').find(':selected').text();
    const conceptNameID = $('#subject_com_type_id').find(':selected').val();
    alert(conceptNameID + ':-  ' + conceptName);
  }

  // lookup and then set the doc_check array with the data.
  getSubjectTemplateDoc(model) {
    this._demoService.getSubjectTemplateDoc(model.doc_id).subscribe(
      (data) => {
        this.doc_check = data;
        const res = data[0];
        // load the drop downs res.doc_ii
        // set the model document id to the new one affidavits.
        model.doc_id = res.doc_id;
        // set the recipeint type for display
        model.brand_type_id = res.brand_type_id;
        this.email_template_name = res.email_template;
        this.email_template_HTML = res.email_template_HTML;
        model.email_template_HTML = res.email_template_HTML;
        model.send_to_invoice = res.send_to_invoice;
        model.send_to_report = res.send_to_report;
        model.send_to_logins = res.send_to_logins;
        model.send_to_primary = res.send_to_primary;
        model.brand_type_id = res.brand_type_id;
        model.send_to_report_user = res.send_to_report_user;

        model.brand_report_id = this.brand_report_id;
        model.brand_invoice_id = this.brand_invoice_id;
        model.brand_report_user_id = this.brand_report_user_id;
        model.subject_id = this.subject_id;

        // load the recipents into an array
        this.getSubjectAgentBrandsAssigned(this.subject_id);
        // load brands - clients into array
        this.getBrand(this.recipient_report_id);
        this.getBrandUsers(this.recipient_report_id);
        this.getBrandAccount(this.accounts_brand_id);

        model.change_dates = '1'; // set to default to system dates changes -- Auust Users must now use dates!
        this.created_file_name = null; // reset the file to be recreated on change
        // iframe

        // Setup Recipients :: New 2022 Model allRecipients
        this.setAllRecipients(model);

         // tslint:disable-next-line:max-line-length

          // this.message_subject = 'Subject: ' +  res.email_subject_header + ' ' + this.subjectFullNameOrBusiness + ' Our Reference: '  + this.subject_number;
          this.message_subject = 'Subject: ' +  res.email_subject_header + ' Our Reference: '  + this.subject_number;
         
          if(model.subject_com_type_id == 3){
            // this.message_subject = 'Reference: ' + this.client_reference + ', ' + 'Subject: ' +  res.email_subject_header + ' ' + this.subjectFullNameOrBusiness + ' Our Reference: '  + this.subject_number;
            this.message_subject = 'Reference: ' + this.client_reference + ', ' +  res.email_subject_header + ' Our Reference: '  + this.subject_number;
          }


         

         model.message_subject = this.message_subject;

        this.url =
        this.gfunc.baseUploadURLEmailTemplatesSSL +
          this.email_template_name;
        this.url_non_ssl =
        this.gfunc.baseUploadURLEmailTemplates +
          this.email_template_name;
        this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);

              // upgrade for attempts paragraphs checker == if 1 then accept. otherwise warn
      // 2.3.1.1
      model.attempt_paragraph_template = res.attempt_paragraph_template;

        //   This DID NOT WORK!  CORS ACCESS ISSUES (will only work online? no cors)
        // HAD TO SETUP SERVER TO ALLOW ACCESS PLESK
        // see:  https://support.plesk.com/hc/en-us/articles/115001338265-How-to-set-up-CORS-cross-origin-resource-sharing-in-Plesk-for-Linux-

        //   if(this.email_template_name != null) {
        //   // get email temlate file as a variable TESTING
        //   fetch(this.url)
        //   .then(response => response.text())
        //   .then(html_data => {
        //   	// Do something with your data
        //     this.html_data = html_data;
        //   	console.log(html_data);
        //   });
        //   // end fetch
        // } // end if no template set
      },
      (err) => console.error(err),
      () => console.log('')
    );
  }



  // :: Method to all default recipients
  setAllRecipients(model) {
      this.allRecipients = [];

    if (model.send_to_report == 1) {
      // 
            // :: Impliments automatic recipients based on chosen com template options
            // :: Subract Method / Filter
            // :: DEMOSERVICE look up client brand details.
            this._demoService.getBrandById(model.brand_report_id).subscribe(
              (data) => {
                // let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED')); // User this if filter is needed.
               let newArr = data;
               let  count_of_items = Object.keys(newArr).length;
                 // need to do a loop of subject_billing items (.length)
                 for(let i=0;i < count_of_items; i++) {
                 let res = newArr[i];
                 this.allRecipients.push({
                   recipient_name: res.name + ' - Client Report',
                   recipient_email_address: res.email,
                   recipient_brand_id: res.brand_id,
                   recipient_brand_type_id: res.brand_type_id,
                   recipient_user_id: null,
                   recipient_user_level_id: null,
                   recipient_type_name: 'Client Report',
                 });
                 } // end for loop
               this.allRecipients = this.allRecipients; // ?? this may be causing errors.

              },
              (err) => console.error(err),
              () => console.log('Client Report Recipient Added.')
            );

        } // end if send_to_report
          
        // AGENT
        if ( model.brand_type_id == 3) { 
          this._demoService.getSubjectAgentBrandsAssigned(model.subject_id).subscribe(
            (data) => {
              // let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED')); // User this if filter is needed.
             let newArr = data;
             let  count_of_items = Object.keys(newArr).length;
               // need to do a loop of subject_billing items (.length)
               for(let i=0;i < count_of_items; i++) {
               let res = newArr[i];
               this.allRecipients.push({
                 recipient_name: res.name + ' - Agent',
                 recipient_email_address: res.email,
                 recipient_brand_id: res.brand_id,
                 recipient_brand_type_id: res.brand_type_id,
                 recipient_user_id: null,
                 recipient_user_level_id: null,
                 recipient_type_name: 'Agent',
               });
               } // end for loop
             this.allRecipients = this.allRecipients; // ?? this may be causing errors.

            },
            (err) => console.error(err),
            () => console.log('Agent Recipients Added.')
          );
          // const key = 'Agent';
          // this.allRecipients.forEach((value, index) => {
          //   if (value.recipient_type_name === key) {
          //     this.allRecipients.splice(index, 1);
          //     console.log('Removed Agent Recipients');
          //   }
          // });
        };

        if (model.send_to_report_user == 1) {

          this._demoService.getUsersById(model.brand_report_user_id).subscribe(
            (data) => {
              // let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED')); // User this if filter is needed.
             let newArr = data;
             let  count_of_items = Object.keys(newArr).length;
               // need to do a loop of subject_billing items (.length)
               for(let i=0;i < count_of_items; i++) {
               let res = newArr[i];
               this.allRecipients.push({
              recipient_name: res.first_name +  ' ' + res.surname + ' - Client Report User',
              recipient_email_address: res.email_address,
              recipient_brand_id: null,
              recipient_brand_type_id: null,
              recipient_user_id: res.user_id,
              recipient_user_level_id: res.access_level,
              recipient_type_name: 'Client Report User',
               });
               } // end for loop
             this.allRecipients = this.allRecipients; // ?? this may be causing errors.

            },
            (err) => console.error(err),
            () => console.log('Client Report User Recipient Added.')
          );
          // const key = 'Client Report User';
          // this.allRecipients.forEach((value, index) => {
          //   if (value.recipient_type_name === key) {
          //     this.allRecipients.splice(index, 1);
          //     console.log('Removed Report User Recipient');
          //   }
          // });
        };

        if (model.send_to_invoice == 1) {
            this._demoService.getBrandById(model.brand_invoice_id).subscribe(
              (data) => {
                // let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED')); // User this if filter is needed.
               let newArr = data;
               let  count_of_items = Object.keys(newArr).length;
                 // need to do a loop of subject_billing items (.length)
                 for(let i=0;i < count_of_items; i++) {
                 let res = newArr[i];
                 this.allRecipients.push({
                   recipient_name: res.name + ' - Client Accounts',
                   recipient_email_address: res.email,
                   recipient_brand_id: res.brand_id,
                   recipient_brand_type_id: res.brand_type_id,
                   recipient_user_id: null,
                   recipient_user_level_id: null,
                   recipient_type_name: 'Client Accounts',
                 });
                 } // end for loop
               this.allRecipients = this.allRecipients; // ?? this may be causing errors.

              },
              (err) => console.error(err),
              () => console.log('Client Accounts Recipient Added.')
            );
        }

        if (model.send_to_logins == 1) {
          this._demoService.getBrandUsers(model.brand_report_id).subscribe(
            (data) => {
              // let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED')); // User this if filter is needed.
             let newArr = data;
             let  count_of_items = Object.keys(newArr).length;
               // need to do a loop of subject_billing items (.length)
               for(let i=0;i < count_of_items; i++) {
               let res = newArr[i];
               this.allRecipients.push({
              recipient_name: res.first_name +  ' ' + res.surname + ' - Client User',
              recipient_email_address: res.email_address,
              recipient_brand_id: null,
              recipient_brand_type_id: null,
              recipient_user_id: res.user_id,
              recipient_user_level_id: res.access_level,
              recipient_type_name: 'Client User',
               });
               } // end for loop
             this.allRecipients = this.allRecipients; // ?? this may be causing errors.

            },
            (err) => console.error(err),
            () => console.log('Client User Recipient Added.')
          );
          // const key = 'Client User';
          // this.allRecipients.forEach((value, index) => {
          //   if (value.recipient_type_name === key) {
          //     this.allRecipients.splice(index, 1);
          //     console.log('Removed Client User Recipients');
          //   }
          // });
        }

        if (model.send_to_primary == 1) {
          this._demoService.getBrandPrimaryContact(model.brand_report_id).subscribe(
            (data) => {
              // let newArr = Object(data).filter((sbi)=>(sbi.invoice_status === 'NOT-INVOICED')); // User this if filter is needed.
             let newArr = data;
             let  count_of_items = Object.keys(newArr).length;
               // need to do a loop of subject_billing items (.length)
               for(let i=0;i < count_of_items; i++) {
               let res = newArr[i];
               this.allRecipients.push({
              recipient_name: res.first_name +  ' ' + res.surname + ' - Client Primary Contact',
              recipient_email_address: res.email_address,
              recipient_brand_id: null,
              recipient_brand_type_id: null,
              recipient_user_id: res.user_id,
              recipient_user_level_id: res.access_level,
              recipient_type_name: 'Client Primary Contact',
               });
               } // end for loop
             this.allRecipients = this.allRecipients; // ?? this may be causing errors.

            },
            (err) => console.error(err),
            () => console.log('Client Primary Contact Added.')
          );
         
         
          // const key = 'Primary Contact';
          // this.allRecipients.forEach((value, index) => {
          //   if (value.recipient_type_name === key) {
          //     this.allRecipients.splice(index, 1);
          //     console.log('Removed Primary Contact Recipient');
          //   }
          // });
        }

  } // end function

  private getBrand(brand_id) {
    this._demoService.getBrandById(brand_id).subscribe(
      (data) => {
        this.brand_data = data;

        this.allClientEmailRecipients = data;

        // let newArr = data
        // let  count_of_items = Object.keys(newArr).length;
        //   // need to do a loop of subject_billing items (.length)
        //   for (let i = 0; i < count_of_items; i++) {
        //   let res = newArr[i];
        //   this.allRecipients.push({
        //     recipient_name: res.name + ' - Client Report',
        //     recipient_email_address: res.email,
        //     recipient_brand_id: res.brand_id,
        //     recipient_brand_type_id: res.brand_type_id,
        //     recipient_user_id: null,
        //     recipient_user_level_id: null,
        //     recipient_type_name: 'Client Report',
        //   });
        //   } // end for loop
        // this.allRecipients = this.allRecipients; // ?? this may be causing errors.

      },
      (err) => console.error(err),
      () => console.log('Brand Loaded.')
    );
  }

  private getBrandAccount(brand_id) {
    this._demoService.getBrandById(brand_id).subscribe(
      (data) => {
        this.brand_account_data = data;

        this.allClientInvoiceEmailRecipients = data;


        // let newArr = data
        // let  count_of_items = Object.keys(newArr).length;
        //   // need to do a loop of subject_billing items (.length)
        //   for (let i = 0; i < count_of_items; i++) {
        //   let res = newArr[i];
        //   this.allRecipients.push({
        //     recipient_name: res.name + ' - Client Accounts',
        //     recipient_email_address: res.email,
        //     recipient_brand_id: res.brand_id,
        //     recipient_brand_type_id: res.brand_type_id,
        //     recipient_user_id: null,
        //     recipient_user_level_id: null,
        //     recipient_type_name: 'Client Accounts',
        //   });
        //   } // end for loop
        // this.allRecipients = this.allRecipients; // ?? this may be causing errors.


      },
      (err) => console.error(err),
      () => console.log('Brand Loaded.')
    );
  }

  getBrandUsers(brand_id) {
    this._demoService.getBrandUsers(brand_id).subscribe(
      (data) => {
        this.brand_user_data = data;

        this.allLoginEmailRecipients = data;

        // let newArr = data
        // let  count_of_items = Object.keys(newArr).length;
        //   // need to do a loop of subject_billing items (.length)
        //   for (let i = 0; i < count_of_items; i++) {
        //   let res = newArr[i];
        //   this.allRecipients.push({
        //     recipient_name: res.first_name +  ' ' + res.surname + ' - Client User',
        //     recipient_email_address: res.email_address,
        //     recipient_brand_id: null,
        //     recipient_brand_type_id: null,
        //     recipient_user_id: res.user_id,
        //     recipient_user_level_id: res.access_level,
        //     recipient_type_name: 'Client User',
        //   });
        //   } // end for loop
        // this.allRecipients = this.allRecipients; // ?? this may be causing errors.

      },
      (err) => console.error(err),
      () => console.log('Candidates Loaded.')
    );
  }

  // get job
  getJob(job_id) {
    this._demoService.getJobID(job_id).subscribe(
      (data) => {
        this.job_data = data;
        let res = data[0];
        // lookup the brand to get the contact details to send to
        this.recipient_brand_id = res.brand_report_id;
        this.recipient_report_id = res.brand_report_id;
        this.accounts_brand_id = res.brand_invoice_id;
        this.getBrand(res.brand_report_id);
        this.getBrandAccount(res.brand_invoice_id);
        this.getBrandUsers(res.brand_report_id);
        this.getBrandPrimaryContact(this.recipient_report_id);
        this.getJobReportUserContact(res.brand_report_user_id);

        this.brand_report_id = res.brand_report_id;
        this.brand_invoice_id = res.brand_invoice_id;
        this.brand_report_user_id = res.brand_report_user_id;

        this.client_reference = res.owner_trace_code;

        // this.next_date = res.next_date;
        // this.final_date = res.final_date;
        // this.job_stati

        //this.model.brand_id = this.recipient_brand_id;
        ///console.log('check brand' + this.recipient_brand_id);
      },
      (err) => console.error(err)
      // () => console.log('done loading Trace Types')
    );
  }

  getSubjectAgentBrandsAssigned(subject_id) {
    this._demoService.getSubjectAgentBrandsAssigned(subject_id).subscribe(
      (data) => {
        this.assignedBrandList = data;

        this.allEmailRecipients = data;

        // let newArr = data
        // let  count_of_items = Object.keys(newArr).length;
        //   // need to do a loop of subject_billing items (.length)
        //   for (let i = 0; i < count_of_items; i++) {
        //   let res = newArr[i];
        //   this.allRecipients.push({
        //     recipient_name: res.name + ' - Agent',
        //     recipient_email_address: res.email,
        //     recipient_brand_id: res.brand_id,
        //     recipient_brand_type_id: res.brand_type_id,
        //     recipient_user_id: null,
        //     recipient_user_level_id: null,
        //     recipient_type_name: 'Agent',
        //   });
        //   } // end for loop
        // this.allRecipients = this.allRecipients; // ?? this may be causing errors.


      },
      (err) => console.error(err),
      // () => console.log('Loaded Assigned Agents Loaded.')
    );
  }

  getUrl(post, email_template) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(
      'https://' + post + '/' + email_template
    );
  }


  // need to get user details
  getBrandPrimaryContact(brand_id) {
  this._demoService.getBrandPrimaryContact(brand_id).subscribe(
     data => { this.primary_contacts = data;

      // let newArr = data
      // let  count_of_items = Object.keys(newArr).length;
      //   // need to do a loop of subject_billing items (.length)
      //   for (let i = 0; i < count_of_items; i++) {
      //   let res = newArr[i];
      //   this.allRecipients.push({
      //     recipient_name: res.first_name +  ' ' + res.surname + ' - Primary Contact',
      //     recipient_email_address: res.email_address,
      //     recipient_brand_id: null,
      //     recipient_brand_type_id: null,
      //     recipient_user_id: res.user_id,
      //     recipient_user_level_id: res.access_level,
      //     recipient_type_name: 'Primary Contact',
      //   });
      //   } // end for loop
      // this.allRecipients = this.allRecipients; // ?? this may be causing errors.


    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


  // need to get user details
  getJobReportUserContact(brand_report_user_id) {
    this._demoService.getUsersById(brand_report_user_id).subscribe(
       data => { this.report_user_contacts = data;
        //  let res = data[0];
  // Run the job data queries.
        // :: Impliments automatic recipients based on chosen com template options (Moved and recoded into a seeperate function)
        // let newArr = data
        // let  count_of_items = Object.keys(newArr).length;
        //   // need to do a loop of subject_billing items (.length)
        //   for (let i = 0; i < count_of_items; i++) {
        //   let res = newArr[i];
        //   this.allRecipients.push({
        //     recipient_name: res.first_name +  ' ' + res.surname + ' - Client Report User',
        //     recipient_email_address: res.email_address,
        //     recipient_brand_id: null,
        //     recipient_brand_type_id: null,
        //     recipient_user_id: res.user_id,
        //     recipient_user_level_id: res.access_level,
        //     recipient_type_name: 'Client Report User',
        //   });
        //   } // end for loop
        // this.allRecipients = this.allRecipients; // ?? this may be causing errors.


      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }


  // Removes Email From Main List. (by ID's)

  RemoveElementFromAllEmailRecipients(key: number) {
    // removes agents
    this.allEmailRecipients.forEach((value, index) => {
      if (value.brand_id === key) {
        this.allEmailRecipients.splice(index, 1);
      }
    });
    // removes clients Report
    this.allClientEmailRecipients.forEach((value, index) => {
      if (value.brand_id === key) {
        this.allClientEmailRecipients.splice(index, 1);
      }
    });
    // removes clients Invoice
    this.allClientInvoiceEmailRecipients.forEach((value, index) => {
      if (value.brand_id === key) {
        this.allClientInvoiceEmailRecipients.splice(index, 1);
      }
    });
    // removes Login Users
    this.allLoginEmailRecipients.forEach((value, index) => {
      if (value.user_id === key) {
        this.allLoginEmailRecipients.splice(index, 1);
      }
    });

    // removes all attachments
    this.allAttachments.forEach((value, index) => {
      if (value.file_name === key) {
        this.allAttachments.splice(index, 1);
      }
    });
  }

  RemoveElementFromAllRecipients(key: number) {
    // removes all matching names, so it can remove multiple accidently. if they have different roles. etc
    this.allRecipients.forEach((value, index) => {
      if (value.recipient_name === key) {
        this.allRecipients.splice(index, 1);
      }
    });

      // :: Specifcally removes the array item without there being
      // :: @https://stackoverflow.com/questions/5767325/how-can-i-remove-a-specific-item-from-an-array

  };


  // MODAL
  // start of modal windows service as a template
// start of modal windows service as a template
openModal(template: TemplateRef<any>) {
  // small upgrade to disable background click on open modal background
  const config = { backdrop: true, ignoreBackdropClick: true, class: 'gray modal-lg' };
  this.modalRef = this.modalService.show(template, config);
}



  createFile(model){
    this._demoService.createFile(model).subscribe(
      data => { this.file_created_response = data;
      // need to get the returned ID to send to log create action

      this.returned_created_file_id = this.file_created_response.last_insert_id;
      console.log(this.returned_created_file_id);


      const subject_com_type_name = (<HTMLSelectElement>document.getElementById('subject_com_type_id')).selectedOptions[0].text;
      console.log('Communication Type Task: ' +  subject_com_type_name);
          //  const subject_com_type_name = document.getElementById('subject_com_type_name').innerText;
           //  console.log('Communication Type Task: ' +  subject_com_type_name);
     const doc_name = document.getElementById('doc_name').innerText;
     console.log('Document Name: ' +  doc_name);

     const log_action = 'created';
     const log_name = 'Subject Communicaiton Task: ' + subject_com_type_name  + ' - ' + doc_name + '';

             const create_sys_log = {
               log_content: JSON.stringify(model), // inserts the entire JSON action into mysql cell
               log_action: log_action, // automated / updated / created / uploaded / link_created / sent
               created_by: this.sessionUserId,
               created_date: this.today,
               subject_id: this.subject_id,
               job_id: this.job_id,
               job_reference_number: model.job_reference_number,
               file_number: model.file_subject_number,
               reference_number: model.job_reference_number,
               subject_number: model.subject_number,
               log_type_id: '1', // see datatable system_log_types
               created_level: this.sessionUserLevel,
               brand_type_id: model.brand_type_id,
               subject_com_type_id: model.subject_com_type_id,
               subject_template_doc_id: model.doc_id,
               log_name: log_name + ' - ' + this.returned_created_file_id,
               file_id: this.returned_created_file_id,
               invoice_id: model.invoice_id,
             };
             this.createSystemLog(create_sys_log);


      },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }

  createSystemLog(model){
    this._demoService.createSystemLog(model).subscribe(
      data => { this.system_log_created_response = data; },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }

  getSubjectInvoices(subject_id){
    this._demoService.getSubjectInvoices(subject_id).subscribe(
      data => {
        this.subject_invoices = data;
    let res = data[0];
    this.current_invoice_id = res.invoice_id;
       },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }



// :: Invoice Upgrades ( Create Invoice From List.)

createDocument_Invoice(model, mergeJobData, invoice_id) {
  // generate more data first
  this._mysqlService.createDocument_Invoice(model, invoice_id).subscribe(
    (data) => {
      // this.trace_candidate_update = data;
      this.toastr.success('Creating Invoice.');
      const res = data;
      console.log(res); // not working as response is showing in body
      // console.log(res._body);
      // console.log(res[0].text()); // Convert response to a string
      // this.created_file_name = res[0].text();
      this.created_file_name = res[0] as string;
      model.attached_file_name = this.created_file_name;
      this.refreshList(); // loads the file list (diretory)
      this.displaySubjectDocuments(this.subject_id, this.subject_number);


      this.set_document_password = res[1] as string;
      console.log('set_document_password: ' + this.set_document_password);

      if(model.encrypt_file == true){
        this.is_encrypted = 1; //  encrypted
      }else{
        this.is_encrypted = 0; // no encrypted
      }

    // set the invoice from the list of invoices (first record)
    if (invoice_id == null){
      invoice_id = this.current_invoice_id;
    }


      // push to global array
      this.allAttachedFiles.push(this.created_file_name);

      // Start the new array of file
      // this.allAttachments.push(this.created_file_name);

      const pushed_file = {
        file_name: this.created_file_name,
        subject_file: 1,
        job_file: 0,
      }; // multidimentional array push
      // this.allAttachments.push(pushed_file); // old way only works for an array.

      // this.empList.push({file_name: this.created_file_name , job_file: 0, subject_file: 1});
      // this.modelds.push({file_name: this.created_file_name , job_file: 0, subject_file: 1});
      this.allAttachments.push({
        file_name: this.created_file_name,
        job_file: 0,
        subject_file: 1,
      });
      model.allAttachments = this.allAttachments; // ?? this may be causing errors.

      // [{name: currencyName, amount: this.ticker[currencyName].last} ]

      // Set the file locations
      //agent

      if (model.brand_type_id === '3') {
      this.file_edit_level = '5'; // agent can edit
      }
      //client
      if (model.brand_type_id === '2') {
        this.file_edit_level = '3'; // client cannot edit  (staff member can)
      }

      const file_server_location = this.gfunc.fileFolderDocs + model.subject_number;
      const file_url = this.gfunc.fileURL + '/' + this.gfunc.fileFolderDocs + model.subject_number + '/' + this.created_file_name;
      const file_folder = this.gfunc.fileFolderDocs + model.subject_number;
      const file_name = this.created_file_name.slice(0, -5); // removes the extension
      const random_file_name = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15); // random string
      // UPGRADE Document Model (Insert the File into the database)
      // File Json
      const create_file = {
        file_name: file_name,
        file_display_name: file_name,
        file_ext: 'pdf',
        file_server_location: file_server_location,
        file_url: file_url,
        file_folder: file_folder,
        file_make: 'created', // automated / updated / created / uploaded / link_created
        file_notes: 'File created via subject communcation UI',
        file_job_id: this.job_id,
        file_subject_id: this.subject_id,
        file_subject_number: this.subject_number,
        created_by: this.sessionUserId,
        created_date: this.today,
        created_level: this.sessionUserLevel,
        file_brand_id: model.brand_report_id,
        file_access_level: '9', // ? who can access this file and below (client or agent) use brand_type_id
        is_active: '1',
        file_password: this.set_document_password,
        file_edit_level: this.file_edit_level,   // what level of user can edit this file (manager default)
        updated_by: this.gfunc.sessionUserId,
        updated_date: this.gfunc.today,
        prev_file_id: '0',    // if updating
        brand_type_id: model.brand_type_id,  // if an agent or a client file
        subject_template_doc_id: model.doc_id,
        subject_com_type_id: model.subject_com_type_id,
        random_file_name: random_file_name,
        full_file_name: this.created_file_name,
        job_id: this.job_id,
        file_number: model.file_number,
        file_reference_number: model.file_reference_number,
        // arrays of sending to - based on subject_template_doc - setup
        agent_access_array: JSON.stringify(this.assignedBrandList), // collect current agent ids
        report_access_array: JSON.stringify(this.brand_data), // collect client
        invoice_access_array: JSON.stringify(this.brand_account_data), // collect client
        user_access_array: JSON.stringify(this.brand_user_data), // of selected associated users.
        invoice_id: invoice_id,
        is_encrypted: 0
      };
     // console.log( (JSON.stringify(this.assignedBrandList)) );
      this.createFile(create_file);

        // :: @ Update the Invoice Status to Approved+PDF (4)
  let invoice_model = {
    invoice_id: invoice_id,
    invoice_status_id: 4,
      };
    this.updateInvoiceStatus(invoice_model);

      // const log_content
      // const log_action
      // Access DOM and get values from HTML template to send to logs
     // const subject_com_type_name = document.getElementsByName('subject_com_type_name');
    // const subject_com_type_name = (<HTMLInputElement>document.getElementById('subject_com_type_name')).value;
    // const subject_com_type_name = (<HTMLElement>document.getElementById('subject_com_type_name'));
    // get the drop down value of text not id.



    },
    (error) => {
      this.toastr.error('Error Creating Document, (if encyption checked) please Check if there must be a Global Company Key set in file recipeint company profile');
     return console.log(error);
    }
  );
}


updateInvoiceStatus(invoice_model){
  this._demoService.updateInvoiceStatus(invoice_model).subscribe(
    data => { // this.trace_candidate_update = data;
      // refresh the invoice:

    },
    error => {
     // console.error('Error saving Event!');
    //  this.toastr.error('Error Changing Status of Subject');
      return console.error(error);
    }
   // err => console.error(err),
   //
  )};



  updateInvoiceCommunicationStatus(invoice_model){
    this._demoService.updateInvoiceCommunicationStatus(invoice_model).subscribe(
      data => { // this.trace_candidate_update = data;
        // refresh the invoice:
      },
      error => {
       // console.error('Error saving Event!');
      //  this.toastr.error('Error Changing Status of Subject');
        // return console.error(error);
      }
     // err => console.error(err),
     //
    )};

pushInvoiceFileToSend(file_name){
  // push to global array
  this.allAttachedFiles.push(file_name);

  // Start the new array of file
  // this.allAttachments.push(this.created_file_name);

  const pushed_file = {
    file_name: file_name,
    subject_file: 1,
    job_file: 0,
  }; // multidimentional array push
  // this.allAttachments.push(pushed_file); // old way only works for an array.

  // this.empList.push({file_name: this.created_file_name , job_file: 0, subject_file: 1});
  // this.modelds.push({file_name: this.created_file_name , job_file: 0, subject_file: 1});
  this.allAttachments.push({
    file_name: file_name,
    job_file: 0,
    subject_file: 1,
  });
 // this.model.allAttachments = this.allAttachments; // ?? this may be causing errors.

 console.log('File_name: ' + file_name);
}



setFileID(file_id){
this.returned_created_file_id = file_id;
console.log('file_id updated: ' + file_id)
};




// syncfusion dialog simple sample
public onOpenDialog2 = function(event: any): void {
  this.DialogObj = DialogUtility.confirm({
    title: 'Communication Processed',
    content: 'Successfully Sent Your Communications.',
    okButton: {  text: 'Ok', click: this.okClick2.bind(this) },
  // cancelButton: {  text: '.', click: this.cancelClick.bind(this) },
  cancelButton: {  text: '.', click: this.okClick2.bind(this) },
  showCloseIcon: true,
    closeOnEscape: true,
    animationSettings: { effect: 'Zoom' }
});
}
public okClick2(): void {
 //  alert('you clicked Yes, Please! are you really really sure??? Really');
 // this.createJobSubjectsMultiple(this.JSON_job);
// this.createJobSubjectsMultiple(this.newSubject);
 this.DialogObj.hide();
 this.gfunc.globalJobSubjectViewSkipRoute(this.subject_id);

}; // end functiiom

private cancelClick2(): void {
   // alert('you clicked Cancel button');
   this.DialogObj.hide();
   this.modalRef.hide(); // hide the modal?
   this.gfunc.globalJobSubjectViewSkipRoute(this.subject_id);
}




subjectChangeDates(model, subject_id) {
  // model.subject_id = this.subject_id; // seemed to be undefined in model?
  if (model.change_dates == 1) {
  this._demoService.updateJobSubjectDates(model, subject_id).subscribe(
    (data) => {
      this.subject_notes = data;
      // console.log("Done loadng USER");
      // console.log(this.users);
      this.toastr.success('Subject Status and Dates Updated');
    },
    (error) => {
      //  console.error('Error Loading User!');
      this.toastr.error('Dates and Status updates failed.');
      return console.error(error);
    }
  );
   } // end if change_dates
}

// :: Parent / Child modal test
closeParentModelDefault(model) {
  // alert('parent component function.');
 // this.modalService.hide(1); - removed the scroll bard do not use!!!
  this.modalRef.hide();
 // this.getJobPlaintiffs(this.job_id);
 // this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div
// :: reset the entire page.
// this.gfunc.globalJobSubjectViewSkipRoute(this.subject_id);
};


// :: Parent / Child modal test
// addRecipientFromModal(model) {
//   // alert('parent component function.');
//  // this.modalService.hide(1); - removed the scroll bard do not use!!!
//   // this.modalRef.hide();
//  // this.getJobPlaintiffs(this.job_id);
//  // this.refreshGrid(); // resets the grid if updated and closed.
// //  this.updateTypeClick = false; // closes the div
// // :: reset the entire page.
// // this.gfunc.globalJobSubjectViewSkipRoute(this.subject_id);

// this.allRecipients.push({
//   recipient_name: model.recipient_name + ' - ' + model.recipient_type_name,
//   recipient_email_address: model.recipient_email_address,
//   recipient_brand_id: null,
//   recipient_brand_type_id: null,
//   recipient_user_id: null,
//   recipient_user_level_id: null,
//   recipient_type_name: model.recipient_type_name,
// });
// this.modalRef.hide();
// console.log('Added External Recipeint.');
// this.toastr.info('External Recipient Added');
// };


addRecipientFromModal(model) {
  // alert('parent component function.');
 // this.modalService.hide(1); - removed the scroll bard do not use!!!
  // this.modalRef.hide();
 // this.getJobPlaintiffs(this.job_id);
 // this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div
// :: reset the entire page.
// this.gfunc.globalJobSubjectViewSkipRoute(this.subject_id);

this.allRecipients.push({
  recipient_name: model.recipient_name + ' - ' + model.recipient_type_name,
  recipient_email_address: model.recipient_email_address,
  recipient_brand_id: null,
  recipient_brand_type_id: null,
  recipient_user_id: null,
  recipient_user_level_id: null,
  recipient_type_name: model.recipient_type_name,
});

this.allRecipients = this.allRecipients;
this.model.allRecipients = this.allRecipients;
model.allRecipients = this.allRecipients;

this.modalRef.hide();
// console.log('Added External Recipeint.');
// this.toastr.info('External Recipient Added');
};





// need to get all associated agents of the job and push thier information to array
getSubjectAgentBrandsAssigned_comms(subject_id) {
  this.allAgentRecipients = [];
  this._demoService.getSubjectAgentBrandsAssigned(subject_id).subscribe(
     data => { 
       this.assignedAgentsList2 = data;

       let newArr = data;
       let  count_of_items = Object.keys(newArr).length;
         // need to do a loop of subject_billing items (.length)
         for(let i=0;i < count_of_items; i++) {
         let res = newArr[i];
         this.allAgentRecipients.push({
           recipient_name: res.name + '',
           recipient_email_address: res.email,
           recipient_brand_id: res.brand_id,
           recipient_subject_id: res.subject_id,
           recipient_brand_type_id: res.brand_type_id,
           recipient_user_id: null,
           recipient_user_level_id: null,
           recipient_type_name: 'Agent',
         });
         } // end for loop
       this.allAgentRecipients = this.allAgentRecipients; // ?? this may be causing errors.
       // set records to send to subject_notes data table
       this.model.assigned_to_agents = JSON.stringify(this.allAgentRecipients);

    },
     err => console.error(err),
     // () => console.log('Loaded Assigned Agents Loaded.')
   );
 }



 RemoveElementFromAllRecipients_comms(key: number) {
  // removes all matching names, so it can remove multiple accidently. if they have different roles. etc
  this.allAgentRecipients.forEach((value, index) => {
    if (value.recipient_name === key) {
      this.allAgentRecipients.splice(index, 1);
    }
  });
    // :: Specifcally removes the array item without there being
    // :: @https://stackoverflow.com/questions/5767325/how-can-i-remove-a-specific-item-from-an-array

};



onChangeLoadAttachments(model){
  this.allAttachments = []; // now sets the varibales needed to send the email files attached.
  // this.allAttachments.push({
  //   file_name: 0,
  //   job_file: 0,
  //   subject_file: 0,
  // });
  model.allAttachments = this.allAttachments; // ?? this may be causing errors.
 // this.toastr.info("we just detected a change!");
}





// Display a modal window informing that there are no attachments on send.

onOpenDialogSendComms = function(event: any, model): void {

  if(this.allAttachments.length <= 0 && this.cancel_clicked != 1){ }// end if.

  this.DialogObj = DialogUtility.confirm({
    title: '<i class="fa fa-paperclip fa-2x text-warning font-bold pull-left"></i> Did you mean to attach or upload a file? ',
    // tslint:disable-next-line:max-line-length
    content: '<i class="fa fa-warning fa-2x text-warning font-bold pull-left"></i> <b> You have not added any files or attachments to this email, are you sure you wish to continue without any files attached?. Close this window to attach files.</p> ',
    okButton: {  text: '<i class="fa fa-check text-success font-bold pull-left"></i> Continue, and send.', click: this.okClickSaveSubject.bind(this, model) },
    cancelButton: {  text: '<i class="fa fa-times text-danger font-bold pull-left"></i> Cancel and Attach Files', click: this.cancelClickSaveSubject.bind(this, model) },
    showCloseIcon: true,
    closeOnEscape: true,
    animationSettings: { effect: 'Zoom' }
});

 
}

public okClickSaveSubject(model): void {
 //  alert('you clicked Yes, Please! are you really really sure??? Really');
 // this.createJobSubjectsMultiple(this.newSubject);
// this.clientJobSubmission(this.job_id);
this.cancel_clicked = 0;
this.click_continue = 1;
this.sendAgentCommunicationEmail(model);
this.DialogObj.hide();
}

public cancelClickSaveSubject(model): void {
   // alert('you clicked Cancel button');
   this.cancel_clicked = 1;
   this.click_continue = 0;
   this.DialogObj.hide();
}


}

// Allows formatting of dates etc...
export class DatePipeComponent {
  today: number = Date.now();
  fixedTimezone = '2018-04-11T09:03:01+1000'; // Fixed to Brisbane Australia
  // tslint:disable-next-line:eofline
}
